import React, { useEffect } from "react";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomVerticalTabs from "components/CustomVerticalTabs/CustomVerticalTabs";
import TabContent from "./TabContent";
import { planActions } from "variables/planActions";

export default function AboutTabs({
  general,
  characteristics,
  reference,
  goals,
  scenarios,
  planActionId,
}) {

  let generalNoData = {},
    characteristicsNoData = {},
    referenceNoData = {},
    goalsNoData = {};

  function NoData(params, noDataObject) {
    for (const [key, value] of Object.entries(params)) {
      noDataObject[key] = "";
    }
  }

  NoData(planActions.general, generalNoData);
  NoData(planActions.characteristics, characteristicsNoData);
  NoData(planActions.reference, referenceNoData);
  NoData(planActions.goals, goalsNoData);

  const data = [
    {
      value: 0,
      name: "Paramètres généraux",
      component: (
        <TabContent apiData={general || generalNoData} params="general" />
      ),
    },

    {
      value: 1,
      name: "Caractéristiques",
      component: (
        <TabContent
          apiData={characteristics || characteristicsNoData}
          params="characteristics"
        />
      ),
    },
    {
      value: 2,
      name: `Référence`,
      component: (
        <TabContent apiData={reference || referenceNoData} params="reference" />
      ),
    },
    {
      value: 3,
      name: `Objectifs`,
      component: <TabContent apiData={goals || goalsNoData} params="goals" />,
    },
  ];

  return <CustomVerticalTabs data={data} />;
}
